import { initBugsnagClient } from '@/libs/bugsnag/client'

initBugsnagClient()
